import { render, staticRenderFns } from "./itemScan.vue?vue&type=template&id=27c883c6&"
import script from "./itemScan.vue?vue&type=script&lang=js&"
export * from "./itemScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports